import API from "../API";

var Calendars = {
    async ListCalendarEvents() {
        var result = await API.process(
            'api/Calendar/Events',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetCalendarEventById(EventID) {
        var result = await API.process(
            `api/Calendar/Event/${EventID}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async CreateCalendarEvents(event) {
        var result = await API.process(
            'api/Calendar/Event',
            'POST',
            event
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListCalendarTypes() {
        var result = await API.process(
            'api/Calendar/Types',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpdateCalendarEvent(cal) {
        var result = await API.process(
            'api/Calendar/Event',
            'PATCH',
            cal
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListCalendarEventTriggers() {
        var result = await API.process(
            'api/Calendar/Triggers',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async CreateCalendarEntry(entry) {
        // Ensure action uses PascalCase EventName property expected by server
        // If action already has eventName (camelCase) copy it to EventName (PascalCase).
        // If action has an id but no EventName, try to fetch the calendar event details
        // so we can include EventName and satisfy server validation.
        const normalizeAction = async (a) => {
            if (!a) return a;
            // If caller passed a string (e.g. 'view-event'), don't spread it (that creates numeric keys)
            if (typeof a === 'string') return { EventName: a };
            const out = { ...a };
            // If action is an object that was created by spreading a string (e.g. {0:'v',1:'i',2:'e'})
            // reconstruct it back to a string and use that as EventName
            const keys = Object.keys(out || {});
            const allNumericKeys = keys.length > 0 && keys.every(k => /^\d+$/.test(k));
            if (!out.EventName && !out.eventName && allNumericKeys) {
                const reconstructed = keys.sort((x, y) => Number(x) - Number(y)).map(k => out[k]).join('');
                if (reconstructed) out.EventName = reconstructed;
            }
            if (!out.EventName && out.eventName) out.EventName = out.eventName;
            // If id exists but EventName is still missing, try to fetch it from API
            if (!out.EventName && (out.id || out.Id)) {
                // prefer id or Id
                const id = out.id ?? out.Id;
                try {
                    // Fallback: ListCalendarEvents returns objects with resource.eventName — use that to resolve name.
                    const allEvents = await Calendars.ListCalendarEvents();
                    const found = allEvents.find(e => (e.resource && (e.resource.id === id || String(e.resource.id) === String(id))) || e.id === id || String(e.id) === String(id));
                    if (found) out.EventName = found.resource?.eventName ?? found.eventName ?? found.EventName ?? out.EventName;
                } catch (e) {
                    // Ignore lookup failures; we'll send whatever we have and let server respond if still invalid
                }
            }
            return out;
        }
        const payload = { ...entry, action: await normalizeAction(entry.action) };
        var result = await API.process(
            `api/Calendar/Entry/${entry.calendar.id}`,
            'POST',
            payload
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetCalendar(userId) {
        var result = await API.process(
            `api/Calendar/Calendar/${userId}`,
            'PATCH',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListCalendarEntries(calendarId) {
        var result = await API.process(
            `api/Calendar/Entries/${calendarId}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListAvaialbeCelendars() {
        var result = await API.process(
            `api/Calendar/User`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListExternalCalendarEntries(CalendarId) {
        var result = await API.process(
            `api/Calendar/Entries/External/${CalendarId}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async SetCalendarEntryAdditionalOption(CalendarEnryId, option) {
        var result = await API.process(
            `api/Calendar/entry/${CalendarEnryId}/option`,
            'POST',
            option
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async LinkCalendar(CalendarEnryId, type, isActive, newDetails) {
        console.log("LinkCalendar", newDetails)
        var result = await API.process(
            `api/Calendar/entry/${CalendarEnryId}/link/${type}/${isActive}`,
            'PUT',
            newDetails
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async DeleteCalendarEntry(EntryId) {
        var result = await API.process(
            `api/Calendar/entry/${EntryId}`,
            'DELETE',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListLinkedCalendars(selectedCalendarEventId) {

        var result = await API.process(
            `api/Calendar/LinkedCalendars/${selectedCalendarEventId}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async UnlinkCalendarFromEvent(selectedCalendarEventId, linkedExternalCalendarId) {

        var result = await API.process(
            `api/Calendar/LinkedCalendars/${selectedCalendarEventId}/Unlink/${linkedExternalCalendarId}`,
            'DELETE',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async InitCalendar(userId) {

        var result = await API.process(
            `api/Calendar/Init/${userId}`,
            'PATCH',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    }
}

export default Calendars;